import React from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import OrdersOverview from "../components/orders/OrdersOverview";

const OrdersPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const initialStatus = searchParams.get("status") ?? undefined;
  const initialRisk   = searchParams.get("risk")   ?? undefined;

  return (
    <Box
      sx={{
        minHeight: "100%",
      }}
    >
      <OrdersOverview initialStatus={initialStatus} initialRisk={initialRisk} />
    </Box>
  );
};

export default OrdersPage;
